// removed by extract-text-webpack-plugin
module.exports = {"component":"_3eg7LoUegFdWhVy-qp4aph","form":"_3PJfc9GWfBvASOgKezs5u6","header":"_3rb20e-gwYc4Ck52R9WQu7","helpText":"_2DHHvcnQsXn8_6CX9Dijg9","message":"tKQzuFCySWIz29OU7YEmP","margins":"_24TCT9Ue9JpPibuHargzSZ","group":"_1U2OW6jMEaVFzh2iWgpKlB","groupStacked":"O6pZ5GBN2k_9x72xm1StZ","control":"_2BmVXfXtkw-YE9njn5Zgtq","label":"wqeTeb_PveT_v4Sm5xXtq","cta":"uP43SpzORshgfGY5DCRWv","btn":"_1u2kl4ysZshRpECijpEmNo","dialog":"_3NaQBLwvvu3TPV0v_VsaES","dialogTitle":"uTqZ3J8BK6u_7oUcalVq5","dialogCta":"_1wf-wdDFSjaAj5_1_9oXWQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/ResetPassword/ResetPasswordForm.css
// module id = 1071
// module chunks = 0